window.addEventListener("load", function () {
    const logDev = (...args) => {
        console.log("GTAG", ...args);
    };

    const installAll = (event, name, root, callback) => {
        if (root) {
            logDev("Installed", name, root);

            root.forEach((el) => {
                el.addEventListener(event, () => callback(el));
            });
        }
    };

    const sendEvent = (event, cat, act, label) => {
        logDev("send event", event, {cat, act, label});
        if (typeof gtag !== "function") {
            console.warn("GTAG not enabled");
            return;
        }

        gtag("event", event, {
            event_category: cat || "",
            event_action: act || "",
            event_label: label || "",
        });
    };
    /////////////////////////////////////////////////
    // Notes:
    // AMO
    // - Book a free designer consultation (https://bedspoke.co.uk/products/abbey-bed-velvet-beige)
    /////////////////////////////////////////////////
    logDev("DOMContentLoaded");

    // 1. Site Header - Phone
    const phoneHeader = document.querySelectorAll(".phone_btn_click");
    installAll("click", "Phone header", phoneHeader, (el) =>
        // event, category, action, label
        sendEvent("phone", "header", "click", "HEADER PHONE ICON clicked")
    );

    // 2. Contact Us - Send Message button
    const eventableForm = document.querySelectorAll('form[data-eventable="true"]');
    installAll("submit", "Eventable form", eventableForm, (el) => {
        const eventName = el.getAttribute("data-event-name");
        if (eventName) {
            sendEvent(eventName, "", "submit", "");
            logDev("eventable form", "installed submit callback");
        }
    });

    // 3. Trade  - JOIN button
    const tradeJoinButton = document.querySelectorAll(".tradeJoinButton");
    installAll("click", "Trade page - Join button", tradeJoinButton, () => {
        sendEvent("traide_join", "trade", "click", "");
    });

    // 4. Designer
    const designer = document.querySelector("#app-embed");
    if (designer) {
        const root = designer.shadowRoot;
        const form = root.querySelector("form");
        form.onsubmit = function () {
            // event, category, action, label
            sendEvent(
                "designer_consultation",
                "",
                "submit",
                "SUBMIT FORM Book a free designer consultation"
            );
        };
    }

    // 5. Call me back
    const callMeBack = document.querySelectorAll("#amoforms_action_btn");
    installAll("click", "Call me button", callMeBack, () => {
        sendEvent("call_me_back_button", "", "click", "Call me back button click");
    });

    // 6. Livechat
    if (window && window.crmPlugin && typeof window.crmPlugin == 'function') {
        const crmPlugin = window.crmPlugin
        crmPlugin('onChatShow', function () {
            sendEvent(
                "livechat",
                "chat",
                "click",
                "Click on button to Open livechat"
            );
        })
        // 7. Whatsapp
        crmPlugin('onButtonClick', function (service, link) {
            logDev("Click Kommo button", service, link)
            if (service === 'whatsapp') {
                sendEvent(
                    "whatsapp",
                    "chat",
                    "click",
                    `Click on WhatsApp button`
                );
            }
        })
    }

    // 8. Order Free Samples
    const orderFreeSamplesButtonNotSide = document.querySelectorAll('.button_order_samples');
    installAll('click', 'Order Free Samples', orderFreeSamplesButtonNotSide, () => {
        sendEvent('order_free_samples', '', 'click', 'Order Free Samples in page button click')
    })

    // 9. Need help (on product page)
    const needHelpOnProductPage = document.querySelectorAll('.help-contact-link');
    installAll('click', 'Need Help ?', needHelpOnProductPage, () => {
        sendEvent('need_help', '', 'click', "Need help? link click on product page")
    })


    /////////////////////////////////////////////////
});